import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { getDoctorProfile } from '../../service/operations/api_methods'
import Cookies from "js-cookie";

const Header = () => {
    const navigate=useNavigate()
         const token = Cookies.get("token")
    const[modal,setModal]=useState(false)
    const[data,setData]=useState(null)

    const handleGetProfile =async()=>{
      try {
        const res= await getDoctorProfile(token)
        console.log(res);
        if(res.status===200){
          setData(res.data.data)
        }
        
      } catch (error) {
        console.log(error);
        
      }
    }
    useEffect(() => {
      handleGetProfile()
    }, [])
    
   
      const location = useLocation() // 2. Use the hook to track current page
    const currentPath = location.pathname;
  return (
    <div className='w-full fixed top-0 z-999' style={{height:"70px",backgroundColor:"white"}}>
     {currentPath === "/"?
      <div className='flex items-center justify-center bg-white p-4 border-black'>
        <p onClick={()=>navigate('/')} style={{fontSize:"26px",fontWeight:"700",cursor:"pointer"}}> Swasthya Khata (Hospital)</p>


       

      </div>
     : 
      <div className='flex items-center justify-between bg-white p-4 border-black'>
        <p onClick={()=>navigate('/dashboard')} style={{fontSize:"26px",fontWeight:"700",cursor:"pointer"}}>Swasthya Khata (Hospital)</p>

         {currentPath!=="/dashboard"&&   <div className='flex items-center justify-center gap-6'>
                <p onClick={()=>navigate('/find-doctors')}
                    className='cursor-pointer text-gray-500 font-bold'>Find Doctors</p>
                     <p onClick={()=>navigate('/find-diagonistics')}
                    className='cursor-pointer text-gray-500 font-bold'>Find Diagonistic</p>
                <p onClick={()=>navigate('/request')}
                    className='cursor-pointer text-gray-500 font-bold'>Request</p>
                     <p onClick={()=>navigate('/patients')}
                    className='cursor-pointer text-gray-500 font-bold'>Patients</p>
            </div>
}
        <p onClick={()=>setModal(!modal)}
        style={{padding:"8px",backgroundColor:"#226df8ff",fontSize:"15px",borderRadius:"10px",color:"white",fontWeight:"700",cursor:"pointer"}}>
          Account</p>

      </div>}

       {modal && 
      <div style={{position:"fixed",top:"80px",right:"30px",width:"200px",height:"160px",backgroundColor:"#fefefe",zIndex:9999999,boxShadow: '0px 0px 15px 5px rgba(0, 0, 0, 0.7)',
        borderRadius:"6px"
      }}> 
      <div style={{padding:"14px"}}>
        <p style={{fontSize:"18px",fontWeight:600,display:"flex",alignItems:"center",gap:"20px"}}>
          <span><img src='/Assets/hospital-user.png'/></span>
          {data?.hospital_name}</p>
        <div style={{borderTop:"1px solid grey",margin:"10px 1px"}}>
         <p style={{fontSize:"14px",fontWeight:"600",}}>License:{data?.license_number}</p>
          <p style={{fontSize:"14px",fontWeight:"600",}}>Address:{data?.address}</p>
          </div>
        </div>

      
        
        </div>}
    </div>
  )
}

export default Header
